import { recordRoadshowEvent } from "../lib/analytics";

type Mode = "reading" | "presentation";

type ModeToggleProps = {
  mode: Mode;
  onModeChange(mode: Mode): void;
};

export function ModeToggle({ mode, onModeChange }: ModeToggleProps) {
  function choose(next: Mode) {
    if (next === mode) return;
    onModeChange(next);
    recordRoadshowEvent({
      sectionId: "global",
      questionId: "mode",
      choice: next,
      eventType: "mode_switch"
    });
  }

  return (
    <div className="mode-toggle" aria-label="页面模式">
      <button type="button" className={mode === "reading" ? "is-active" : ""} onClick={() => choose("reading")}>
        阅读
      </button>
      <button
        type="button"
        className={mode === "presentation" ? "is-active" : ""}
        onClick={() => choose("presentation")}
      >
        演讲
      </button>
    </div>
  );
}
